import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RecipientOrganizationModel } from 'core/models/recipient.model';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { NgFor, NgIf } from '@angular/common';
import { differentValueValidator } from 'core/utils/different-value.validator';
import { ChangeRecipientPopupData } from './change-recipient-popup.interface';

@Component({
    standalone: true,
    selector: 'dc-change-recipient-popup',
    templateUrl: './change-recipient-popup.component.html',
    styleUrls: ['./change-recipient-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        TranslatePipe,
        MatRadioGroup,
        MatRadioButton,
        NgFor,
        MatError,
        NgIf,
    ],
})
export class ChangeRecipientPopupComponent implements OnInit {
    submitted = false;

    public recipientControl = new FormControl<number | null>(null, [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<ChangeRecipientPopupComponent>,
        public translate: TranslateService,
        @Inject(MAT_DIALOG_DATA)
        public data: ChangeRecipientPopupData,
    ) {}

    ngOnInit() {
        if (this.data.currentRecipient) {
            this.recipientControl.setValue(this.data.currentRecipient.Id);
            this.recipientControl.setValidators([
                Validators.required,
                differentValueValidator(this.data.currentRecipient.Id),
            ]);
        }
    }

    submit(): void {
        if (this.recipientControl.invalid) {
            this.recipientControl.markAsTouched();
            return;
        }

        this.dialogRef.close(
            this.data.recipients.find(recipient => recipient.Id === this.recipientControl.value),
        );
    }

    close(): void {
        this.dialogRef.close();
    }
}
